import {Loading, LoadingInitState} from './loading.types';
import {LoadingAction} from './loading.actions';
import {LoadingMutations} from './loading.mutations';

const namespaced = true;

export const loadingInitState: LoadingInitState = {
  Load: {
    loading: false
  } as Loading
};

export const loadingState = {
  namespaced,
  state: loadingInitState,
  actions: LoadingAction,
  mutations: LoadingMutations
};
